import React from 'react';
import PropTypes from 'prop-types';

import FormPage from './FormPage';
import PDFPage from './PDFPage';

const Page = (props) => {

  const { backgroundImage } = props;

  const PageNode = backgroundImage ? PDFPage : FormPage;

  return <PageNode {...props} />;

};

Page.propTypes = {
  backgroundImage: PropTypes.string
};

export default React.memo(Page);
